import { createDateFromYYYYMMDD } from '../../../utilities/DateUtils'
import * as FormConstants from '../../../utilities/FormHelperUtils'
import * as GeneralUtils from '../../../utilities/GeneralUtils'
import { translate } from '../../../utilities/TranslationUtils'
import { validate, validateIfValue } from '../../../utilities/ValidationUtils'
import {
  TYPE_IMAGE,
  TYPE_INFOBLOCK,
  TYPE_LABEL,
  TYPE_MULTICHILD,
  TYPE_TIME,
} from './DynamicDataCmp'

export const CONSTRAINT_TYPE_BASE = 'typeBase'
export const CONSTRAINT_TYPE_DATE_TIME = 'typeDateTime'
export const CONSTRAINT_TYPE_NUMERIC = 'typeNumeric'
export const CONSTRAINT_TYPE_TEXT = 'typeText'

export function validateInput(input, value, intlObj) {
  let errors = []
  if (
    input.type !== TYPE_LABEL &&
    input.type !== TYPE_INFOBLOCK &&
    input.type !== TYPE_IMAGE &&
    input.type !== TYPE_MULTICHILD
  ) {
    if (input.constraints !== undefined && input.constraints.length > 0) {
      for (const constraint of input.constraints) {
        const e = validateConstraint(constraint, value, intlObj, input)
        errors = errors.concat(e)
      }
    }
  }

  return errors
}

export function validateConstraint(constraint, value, intlObj, input) {
  if (constraint.type === CONSTRAINT_TYPE_BASE) {
    return validateBaseConstraint(constraint, value, intlObj)
  } else if (constraint.type === CONSTRAINT_TYPE_TEXT) {
    return validateTextConstraint(constraint, value, intlObj)
  } else if (constraint.type === CONSTRAINT_TYPE_NUMERIC) {
    return validateNumericConstraint(constraint, value, intlObj)
  } else if (constraint.type === CONSTRAINT_TYPE_DATE_TIME) {
    return validateDateConstraint(constraint, value, intlObj, input)
  }
}

export function validateBaseConstraint(constraint, value, intlObj) {
  const errors = []
  if (constraint.mandatory) {
    addError(
      errors,
      validate(intlObj, {
        value,
        required: true,
      }),
    )
  }
  const acceptableValues = []

  if (
    constraint.acceptableValuesLite !== undefined &&
    !GeneralUtils.isEmpty(constraint.acceptableValuesLite) &&
    constraint.acceptableValuesLite.length > 0
  ) {
    for (const acceptableValueLite of constraint.acceptableValuesLite) {
      acceptableValues.push(acceptableValueLite.value)
    }
  } else if (
    constraint.acceptableValues !== undefined &&
    !GeneralUtils.isEmpty(constraint.acceptableValues) &&
    constraint.acceptableValues.length > 0
  ) {
    for (const acceptableValue of constraint.acceptableValues) {
      acceptableValues.push(acceptableValue.value)
    }

    // let acceptable = false
    // for (let acceptableValue of constraint.acceptableValues) {
    //   if (acceptableValue.value === value) {
    //     acceptable = true
    //   }
    // }
    // if (!acceptable) {
    //   errors.push(intlIt(intlObj, 'errors.fields.value.required'))
    // }
  }

  if (!GeneralUtils.isEmpty(acceptableValues)) {
    addError(
      errors,
      validate(intlObj, {
        value,
        acceptableValues,
      }),
    )
  }

  return errors
}

export function validateTextConstraint(constraint, value, intlObj) {
  const errors = validateBaseConstraint(constraint, value, intlObj)
  if (constraint.email) {
    addError(
      errors,
      validateIfValue(intlObj, {
        value,
        isEmail: true,
      }),
    )
  } else if (constraint.phone) {
    addError(
      errors,
      validateIfValue(intlObj, {
        value,
        isPhone: true,
      }),
    )
  } else {
    if (constraint.minLength > 0) {
      addError(
        errors,
        validateIfValue(intlObj, {
          value,
          minChars: constraint.minLength,
        }),
      )
    }
    if (constraint.maxLength >= 0) {
      addError(
        errors,
        validateIfValue(intlObj, {
          value,
          maxChars: constraint.maxLength,
        }),
      )
    }
  }

  return errors
}

export function validateNumericConstraint(constraint, value, intlObj) {
  const errors = validateBaseConstraint(constraint, value, intlObj)
  if (constraint.testMinValue && constraint.testMaxValue) {
    addError(
      errors,
      validateIfValue(intlObj, {
        value,
        minNum: constraint.minValue,
        maxNum: constraint.maxValue,
        allowDecimal: constraint.allowDecimal,
        maxDecimalPlaces: constraint.maxDecimalPlaces,
        isCurrency: constraint.currency,
      }),
    )
  } else {
    if (constraint.testMinValue) {
      addError(
        errors,
        validateIfValue(intlObj, {
          value,
          minNum: constraint.minValue,
          allowDecimal: constraint.allowDecimal,
          maxDecimalPlaces: constraint.maxDecimalPlaces,
          isCurrency: constraint.currency,
        }),
      )
    }
    if (constraint.testMaxValue) {
      addError(
        errors,
        validateIfValue(intlObj, {
          value,
          maxNum: constraint.maxValue,
          allowDecimal: constraint.allowDecimal,
          maxDecimalPlaces: constraint.maxDecimalPlaces,
          isCurrency: constraint.currency,
        }),
      )
    }
  }

  return errors
}

export function validateDateConstraint(constraint, value, intlObj, input) {
  const errors = []
  if (constraint.mandatory) {
    addError(
      errors,
      validate(intlObj, {
        value,
        required: true,
        isDateLiteral: true,
      }),
    )
  }

  if (!GeneralUtils.isEmpty(constraint.minDate)) {
    addError(
      errors,
      validateIfValue(intlObj, {
        value,
        minDateLiteral: constraint.minDate,
        isDateLiteral: true,
      }),
    )
  }

  if (!GeneralUtils.isEmpty(constraint.maxDate)) {
    addError(
      errors,
      validateIfValue(intlObj, {
        value,
        maxDateLiteral: constraint.maxDate,
        isDateLiteral: true,
      }),
    )
  }

  let use24HourFormatForMsgs = true
  if (input.type === TYPE_TIME) {
    use24HourFormatForMsgs = input.use24HourFormat
  }

  if (!GeneralUtils.isEmpty(constraint.minTime)) {
    addError(
      errors,
      validateIfValue(intlObj, {
        value,
        minTimeLiteral: constraint.minTime,
        isDateLiteral: true,
        use24HourFormatForMsgs,
      }),
    )
  }

  if (!GeneralUtils.isEmpty(constraint.maxTime)) {
    addError(
      errors,
      validateIfValue(intlObj, {
        value,
        maxTimeLiteral: constraint.maxTime,
        isDateLiteral: true,
        use24HourFormatForMsgs,
      }),
    )
  }

  return errors
}

export function addError(errors, result) {
  if (!GeneralUtils.isEmpty(result)) {
    for (const item of result) {
      errors.push(item)
    }
  }
}

export function createObjFromParams(params) {
  const obj = {}
  if (!GeneralUtils.isEmpty(params) && params.length > 0) {
    for (const param of params) {
      obj[param.name] = param.value
    }
  }

  return obj
}

export function intlIt(
  intlObj,
  token,
  defaultText = '',
  literalValues = {},
  params = null,
) {
  if (params !== null) {
    literalValues = createObjFromParams(params)
  }

  return translate(intlObj, token, literalValues, null, defaultText)
}

export function isMandatory(input) {
  let mandatory = false

  if (input.constraints !== undefined && input.constraints.length > 0) {
    for (const constraint of input.constraints) {
      if (constraint.mandatory) {
        mandatory = true
      }
    }
  }

  return mandatory
}

export function convertObjToDynamicDataResponse(dataObj) {
  const dataArr = []
  for (const key in dataObj) {
    const value = dataObj[key]
    if (value !== null && GeneralUtils.isArray(value)) {
      dataArr.push({
        name: key,
        valueList: dataObj[key],
      })
    } else {
      dataArr.push({
        name: key,
        value: dataObj[key],
      })
    }
  }
  const ddr = { responses: dataArr }

  return ddr
}

export function isInputTypeEmail(input) {
  let isEmail = false
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_TEXT && constraint.email) {
        isEmail = true
        break
      }
    }
  }

  return isEmail
}

export function isInputTypeNumber(input) {
  let isNumber = false
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_NUMERIC) {
        isNumber = true
        break
      }
    }
  }

  return isNumber
}

// export function isInputTypeDate (input) {
//   let isDate = false
//   if (isValidatableInput(input)) {
//     for (const constraint of input.constraints) {
//       if (constraint.type === CONSTRAINT_TYPE_DATE_TIME) {
//         isDate = true
//         break
//       }
//     }
//   }

//   return isDate
// }

export function getInputType(input) {
  let inputType = FormConstants.INPUT_TYPES.TEXT
  if (input.multiLine) {
    inputType = FormConstants.TEXTAREA
  } else if (isInputTypeEmail(input)) {
    inputType = FormConstants.INPUT_TYPES.EMAIL
  } else if (isInputTypeNumber(input)) {
    inputType = FormConstants.INPUT_TYPES.NUMBER
  }

  return inputType
}

export function getNumberTypeStep(input) {
  let step = null
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_NUMERIC) {
        if (constraint.allowDecimal) {
          let zeroes = ''
          for (let i = 1; i < constraint.maxDecimalPlaces; i++) {
            zeroes += '0'
            step = `.${zeroes}1`
          }
          break
        }
      }
    }
  }

  return step
}

export function getMinNumber(input) {
  let minValue = 0
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_NUMERIC) {
        if (constraint.testMinValue) {
          minValue = constraint.minValue
          break
        }
      }
    }
  }

  return minValue
}

export function getMaxNumber(input) {
  let maxValue = null
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_NUMERIC) {
        if (constraint.testMaxValue) {
          maxValue = constraint.maxValue
          break
        }
      }
    }
  }

  return maxValue
}

export function getMaxLength(input) {
  let maxLength = null
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_TEXT) {
        if (constraint.maxLength) {
          maxLength = constraint.maxLength
          break
        }
      }
    }
  }

  return maxLength
}

export function getMinDate(input) {
  let minDate = null
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_DATE_TIME) {
        if (!GeneralUtils.isEmpty(constraint.minDate)) {
          minDate = createDateFromYYYYMMDD(constraint.minDate)
          break
        }
      }
    }
  }

  return minDate
}

export function getMaxDate(input) {
  let maxDate = null
  if (isValidatableInput(input)) {
    for (const constraint of input.constraints) {
      if (constraint.type === CONSTRAINT_TYPE_DATE_TIME) {
        if (!GeneralUtils.isEmpty(constraint.maxDate)) {
          maxDate = createDateFromYYYYMMDD(constraint.maxDate)
          break
        }
      }
    }
  }

  return maxDate
}

export function isValidatableInput(input) {
  let isValidatable = false
  if (
    input.type !== TYPE_LABEL &&
    input.type !== TYPE_INFOBLOCK &&
    input.type !== TYPE_IMAGE
  ) {
    if (input.constraints !== undefined && input.constraints.length > 0) {
      isValidatable = true
    }
  }

  return isValidatable
}
